(() => {
  const timerSelector = '.cart-drawer .cart-timer';
  const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const dispatchDays = new Set(['Mon', 'Wed', 'Fri']);
  const cutoffSeconds = 12 * 60 * 60;
  const urgencyWindowSeconds = 24 * 60 * 60;

  const getBuenosAiresTime = () => {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Argentina/Buenos_Aires',
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(new Date());
    const value = (type) => parts.find((part) => part.type === type)?.value;

    return {
      weekday: value('weekday'),
      hour: Number(value('hour')),
      minute: Number(value('minute')),
      second: Number(value('second'))
    };
  };

  const getDispatchStatus = () => {
    const now = getBuenosAiresTime();
    const weekdayIndex = weekdays.indexOf(now.weekday);
    const currentSeconds = (now.hour * 60 + now.minute) * 60 + now.second;
    const isSameDayWindow = dispatchDays.has(now.weekday) && currentSeconds < cutoffSeconds;

    if (isSameDayWindow) {
      const remaining = Math.max(cutoffSeconds - currentSeconds, 0);
      const hours = String(Math.floor(remaining / 3600)).padStart(2, '0');
      const minutes = String(Math.floor((remaining % 3600) / 60)).padStart(2, '0');
      const seconds = String(remaining % 60).padStart(2, '0');

      return {
        visible: true,
        mode: 'urgent',
        text: `Comprá en ${hours}:${minutes}:${seconds} y preparamos tu pedido hoy`
      };
    }

    for (let daysAhead = 1; daysAhead <= 7; daysAhead += 1) {
      const candidateIndex = (weekdayIndex + daysAhead) % 7;
      if (dispatchDays.has(weekdays[candidateIndex])) {
        const secondsUntilDispatch = (daysAhead * 24 * 60 * 60) + cutoffSeconds - currentSeconds;
        if (secondsUntilDispatch <= urgencyWindowSeconds) {
          return {
            visible: true,
            mode: 'tomorrow',
            text: 'Pedí ahora y preparamos tu pedido mañana'
          };
        }
        break;
      }
    }

    return { visible: false, mode: 'hidden', text: '' };
  };

  const ensureStyles = () => {
    if (document.getElementById('kora-dispatch-timing-styles')) return;
    const style = document.createElement('style');
    style.id = 'kora-dispatch-timing-styles';
    style.textContent = `
      .cart-drawer .cart-timer.kora-dispatch-timing {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: .45rem;
        margin: 0 0 1.2rem !important;
        padding: .75rem 1rem;
        border-radius: 99rem;
        background: #f7f3f1 !important;
        color: #4d4240 !important;
        font-size: 1.25rem !important;
        font-weight: 750;
        line-height: 1.25;
        text-align: center;
      }
      .cart-drawer .cart-timer.kora-dispatch-timing[hidden] {
        display: none !important;
      }
      .cart-drawer .cart-timer.kora-dispatch-timing[data-mode="urgent"],
      .cart-drawer .cart-timer.kora-dispatch-timing[data-mode="tomorrow"] {
        background: #fff0f0 !important;
        color: #971a24 !important;
      }
      .kora-dispatch-timing__icon { flex: 0 0 auto; }
    `;
    document.head.appendChild(style);
  };

  const initializeTimer = (timer) => {
    if (timer.dataset.koraDispatchReady === 'true') return;
    timer.dataset.koraDispatchReady = 'true';
    timer.classList.add('kora-dispatch-timing');
    timer.innerHTML = '<span class="kora-dispatch-timing__icon" aria-hidden="true">⚡</span><span data-kora-dispatch-copy></span>';
  };

  const refreshTimers = () => {
    const status = getDispatchStatus();
    document.querySelectorAll(timerSelector).forEach((timer) => {
      initializeTimer(timer);
      const cartItems = timer.closest('cart-drawer')?.querySelector('cart-drawer-items');
      const delayedBiri = timer.closest('cart-drawer')?.querySelector('[data-kora-biri-last-batch="cart"]');
      const delayedBiriEnd = Date.parse(delayedBiri?.dataset.campaignEnd || '');
      const hasActiveDelayedBiri = Boolean(delayedBiri && !delayedBiri.hidden && Number.isFinite(delayedBiriEnd) && Date.now() < delayedBiriEnd);
      timer.hidden = Boolean(cartItems?.classList.contains('is-empty')) || hasActiveDelayedBiri || !status.visible;
      timer.dataset.mode = status.mode;
      const copy = timer.querySelector('[data-kora-dispatch-copy]');
      if (copy && copy.textContent !== status.text) copy.textContent = status.text;
    });
  };

  const boot = () => {
    ensureStyles();
    refreshTimers();
    window.setInterval(refreshTimers, 1000);
    new MutationObserver(refreshTimers).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
